import React from 'react';
import { X } from 'lucide-react';

interface FilterChipProps {
  label: string;
  onRemove: () => void;
  variant?: 'primary' | 'secondary';
}

export function FilterChip({ label, onRemove, variant = 'primary' }: FilterChipProps) {
  const variantClasses = {
    primary: 'bg-brand-primary text-white',
    secondary: 'bg-background-secondary text-text-primary border border-border-primary'
  };

  return (
    <div className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full ${variantClasses[variant]}`}>
      <span>{label}</span>
      <button
        onClick={onRemove}
        className="hover:bg-white/20 rounded-full p-0.5 transition-colors"
        aria-label={`Remove ${label} filter`}
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  );
}